(() => {
  const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';

  const text = (value) => value == null ? '' : String(value);

  const appendTextElement = (parent, tagName, className, value) => {
    const element = document.createElement(tagName);
    if (className) element.className = className;
    element.textContent = text(value);
    parent.appendChild(element);
    return element;
  };

  const createCheckmarkIcon = (isSwatch) => {
    const icon = document.createElementNS(SVG_NAMESPACE, 'svg');
    icon.setAttribute('class', `facet-checkbox__box__icon icon icon-checkmark${isSwatch ? ' facet-checkbox__box__icon--visual' : ''}`);
    icon.setAttribute('width', '10');
    icon.setAttribute('height', '8');
    icon.setAttribute('viewBox', '0 0 10 8');
    icon.setAttribute('fill', 'none');

    const use = document.createElementNS(SVG_NAMESPACE, 'use');
    use.setAttribute('href', '#icon-facet-check');
    icon.appendChild(use);

    return icon;
  };

  const createFacetItem = (item) => {
    if (!item || typeof item !== 'object' || item.active || !item.input_id || !item.param_name) return null;

    const isSwatch = item.presentation === 'swatch';
    const isImage = item.presentation === 'image';
    const isColorFilter = Boolean(item.is_color_filter);
    const li = document.createElement('li');
    li.className = `facets__item flex align-center show-more-item hidden${isImage ? ' facets__item--image' : ''}`;

    const label = document.createElement('label');
    label.htmlFor = text(item.input_id);
    label.className = `facet-checkbox flex-grow-1 por flex align-center${item.disabled ? ' facet-checkbox--disabled' : ''}`;

    const input = document.createElement('input');
    input.type = 'checkbox';
    input.name = text(item.param_name);
    input.value = text(item.value);
    input.id = text(item.input_id);
    input.disabled = Boolean(item.disabled);
    input.className = `facets__checkbox-value${isColorFilter || isSwatch ? ' facets__checkbox-value--color' : ''}`;
    label.appendChild(input);

    if (isImage) {
      const imageWrapper = document.createElement('div');
      imageWrapper.className = 'facets__image-wrapper flex flex-column w100 por';

      const imageInner = document.createElement('div');
      imageInner.className = 'facets__image-inner';
      if (item.image_url) {
        const media = document.createElement('div');
        media.className = 'facets__image media media--square';
        const image = document.createElement('img');
        image.className = 'facets__image';
        image.src = text(item.image_url);
        image.alt = text(item.image_alt);
        media.appendChild(image);
        imageInner.appendChild(media);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'facets__image media media--square placeholder db';
        imageInner.appendChild(placeholder);
      }
      imageWrapper.appendChild(imageInner);

      const imageLabel = document.createElement('span');
      imageLabel.setAttribute('aria-hidden', 'true');
      imageLabel.className = 'flex-grow-1 center';
      appendTextElement(imageLabel, 'span', 'facets__image-label caption font-body-semi-bold', item.label);
      imageWrapper.appendChild(imageLabel);
      appendTextElement(imageWrapper, 'span', 'facets__image-count flex justify-center align-center lh1 font-body-semi-bold', item.count);
      label.appendChild(imageWrapper);
    } else {
      const box = document.createElement('span');
      box.className = `flex justify-center align-center facet-checkbox__box${isColorFilter || isSwatch ? ' facet-checkbox__box--color' : ''}`;
      if (isColorFilter || (isSwatch && item.swatch_image_url)) {
        box.dataset.color = text(item.color_handle);
      }
      if (isSwatch) {
        if (item.swatch_image_url) {
          box.style.setProperty('--background-image', `url("${text(item.swatch_image_url)}")`);
          if (item.swatch_focal_point) {
            box.style.setProperty('--background-position', text(item.swatch_focal_point));
          }
        } else if (item.swatch_color) {
          const { red, green, blue } = item.swatch_color;
          if ([red, green, blue].every((channel) => Number.isFinite(Number(channel)))) {
            box.style.setProperty('--color-swatch-background', `${red},${green},${blue}`);
          }
        }
      }
      box.appendChild(createCheckmarkIcon(isSwatch));
      label.appendChild(box);

      const content = document.createElement('span');
      content.setAttribute('aria-hidden', 'true');
      content.className = 'flex facet-checkbox__content flex-grow-1 justify-space-between align-center';
      appendTextElement(content, 'span', 'facet-checkbox__content__label caption-large', item.label);
      appendTextElement(content, 'span', 'facet-checkbox__content__count flex justify-center align-center lh1', item.count);
      label.appendChild(content);
    }

    appendTextElement(label, 'span', 'visually-hidden', item.accessible_label);
    li.appendChild(label);
    return li;
  };

  const hydrateOverflowFacets = () => {
    document.querySelectorAll('script.jl-facet-overflow').forEach((script) => {
      if (script.dataset.hydrated === 'true') return;

      const target = document.getElementById(script.dataset.target);
      if (!target || target.tagName !== 'UL') return;

      // CUSTOM-START SPEED-102: reuse desktop overflow values for the mobile drawer.
      const source = script.dataset.source
        ? [...document.querySelectorAll('script.jl-facet-overflow')].find((item) => item.dataset.target === script.dataset.source)
        : script;
      if (!source) return;
      let values;
      try {
        values = JSON.parse(source.textContent);
      } catch (error) {
        return;
      }
      if (!Array.isArray(values)) return;
      if (script.dataset.source) {
        values = values.map((item) => ({ ...item, input_id: item.input_id.replace('Filter-Desktop-', 'Filter-Mobile-') }));
      }
      // CUSTOM-END SPEED-102

      const items = document.createDocumentFragment();
      values.forEach((item) => {
        const facetItem = createFacetItem(item);
        if (facetItem) items.appendChild(facetItem);
      });
      target.appendChild(items);
      script.dataset.hydrated = 'true';
    });
  };

  // CUSTOM-START SPEED-102: section rendering replaces facets after a filter change.
  const start = () => {
    hydrateOverflowFacets();
    new MutationObserver((records) => {
      if (records.some((record) => [...record.addedNodes].some((node) =>
        node.nodeType === 1 && (node.matches?.('script.jl-facet-overflow') || node.querySelector?.('script.jl-facet-overflow'))
      ))) hydrateOverflowFacets();
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  // CUSTOM-END SPEED-102
})();
